import { useState } from 'react';

const footerLinks = {
  核心板块: [
    { label: '元宇宙平台', href: '#metaverse' },
    { label: '6G-7G网络', href: '#network' },
    { label: 'Web5.0协议', href: '#network' },
    { label: 'XR体验中心', href: '#xr' },
    { label: '数字经济', href: '#economy' },
    { label: '开发者中心', href: '#developer' },
  ],
  前沿科技: [
    { label: '脑机接口', href: '#future' },
    { label: '量子计算', href: '#future' },
    { label: '空间计算', href: '#future' },
    { label: '未来展望', href: '#future-vision' },
    { label: '前沿培训', href: '#training' },
    { label: '元宇宙时讯', href: '#news-timeline' },
  ],
  社区生态: [
    { label: '元界星图BBS', href: '#bbs' },
    { label: '站长专栏', href: '#column' },
    { label: '友情链接', href: '#friend-links' },
    { label: '生态伙伴', href: '#partners' },
    { label: '开发者论坛', href: '#developer' },
    { label: '联系我们', href: '/contact' },
  ],
};

const socialLinks = [
  { icon: 'ri-twitter-x-line', href: '#', label: 'X/Twitter' },
  { icon: 'ri-discord-line', href: '#', label: 'Discord' },
  { icon: 'ri-telegram-line', href: '#', label: 'Telegram' },
  { icon: 'ri-github-line', href: '#', label: 'GitHub' },
  { icon: 'ri-wechat-line', href: '#', label: 'WeChat' },
  { icon: 'ri-youtube-line', href: '#', label: 'YouTube' },
];

const doodleColors = ['#00FF88', '#FFD700', '#FF6B9D', '#00FFCC', '#FF6B35', '#A855F7'];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append('email', email);
      await fetch('https://readdy.ai/api/form/d77ircsggtbbtt19rkn0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer id="contact" className="relative overflow-hidden" style={{ background: '#0D1A12' }}>
      {/* Doodle background decorations */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {/* Doodle grid */}
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'linear-gradient(rgba(0,255,136,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(0,255,136,0.4) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }} />
        {/* Colorful splats */}
        <div className="absolute top-10 left-20 w-64 h-64 rounded-full opacity-10" style={{ background: 'radial-gradient(ellipse, #00FF88 0%, transparent 70%)' }} />
        <div className="absolute top-20 right-32 w-48 h-48 rounded-full opacity-8" style={{ background: 'radial-gradient(ellipse, #FFD700 0%, transparent 70%)' }} />
        <div className="absolute bottom-40 left-1/3 w-56 h-56 rounded-full opacity-8" style={{ background: 'radial-gradient(ellipse, #FF6B9D 0%, transparent 70%)' }} />
        <div className="absolute bottom-20 right-20 w-40 h-40 rounded-full opacity-8" style={{ background: 'radial-gradient(ellipse, #00FFCC 0%, transparent 70%)' }} />
        {/* Doodle wavy top border */}
        <svg className="absolute top-0 left-0 w-full" height="8" viewBox="0 0 1440 8" preserveAspectRatio="none">
          <path d="M0,4 Q90,0 180,4 Q270,8 360,4 Q450,0 540,4 Q630,8 720,4 Q810,0 900,4 Q990,8 1080,4 Q1170,0 1260,4 Q1350,8 1440,4" stroke="#00FF88" strokeWidth="2" fill="none" strokeOpacity="0.4"/>
        </svg>
        {/* Floating doodle stars */}
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute text-lg opacity-20"
            style={{
              left: `${10 + i * 12}%`,
              top: `${15 + (i % 3) * 25}%`,
              color: doodleColors[i % doodleColors.length],
              fontFamily: 'Caveat, cursive',
              fontSize: `${14 + (i % 3) * 6}px`,
              transform: `rotate(${-20 + i * 10}deg)`,
            }}
          >
            {['✦', '★', '◆', '✿', '❋', '✺', '⬟', '✧'][i]}
          </div>
        ))}
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Top Section - Brand + Subscribe */}
        <div className="pt-16 pb-12 border-b border-white/8">
          <div className="flex flex-col lg:flex-row gap-12 items-start">
            {/* Brand Block */}
            <div className="lg:w-80 flex-shrink-0">
              {/* Logo */}
              <div className="flex items-center gap-3 mb-5">
                <div
                  className="w-12 h-12 flex items-center justify-center"
                  style={{
                    background: 'rgba(0,255,136,0.15)',
                    border: '2px solid rgba(0,255,136,0.5)',
                    borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%',
                  }}
                >
                  <span className="text-[#00FF88] font-black text-xl" style={{ fontFamily: 'Orbitron, sans-serif' }}>M</span>
                </div>
                <div>
                  <span className="text-white font-black text-2xl tracking-widest block" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                    META<span className="text-[#00FF88]">66</span>
                  </span>
                  <span className="text-white/30 text-xs" style={{ fontFamily: 'Caveat, cursive' }}>元宇宙 · 数字文明 · 未来先行</span>
                </div>
              </div>
              <p className="text-white/40 text-sm leading-relaxed mb-6">
                中国领先的元宇宙垂直综合资讯与生态平台，深度布局6G超连接、Web5.0去中心化协议、XR沉浸体验与量子安全技术，连接全球数字文明建设者。
              </p>
              {/* Social Links */}
              <div className="flex flex-wrap gap-2">
                {socialLinks.map((s) => (
                  <a
                    key={s.icon}
                    href={s.href}
                    title={s.label}
                    className="w-9 h-9 flex items-center justify-center text-white/40 hover:text-[#00FF88] transition-all duration-300 cursor-pointer"
                    style={{
                      border: '1.5px solid rgba(255,255,255,0.12)',
                      borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%',
                    }}
                  >
                    <i className={`${s.icon} text-sm`} />
                  </a>
                ))}
              </div>
            </div>

            {/* Links Grid */}
            <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-8">
              {Object.entries(footerLinks).map(([category, links]) => (
                <div key={category}>
                  <p
                    className="text-[#00FF88] text-sm font-bold mb-4 tracking-wider"
                    style={{ fontFamily: 'Caveat, cursive', fontSize: '1rem' }}
                  >
                    {category}
                  </p>
                  <div className="flex flex-col gap-2.5">
                    {links.map((link) => (
                      <a
                        key={link.label}
                        href={link.href}
                        className="text-white/40 text-sm hover:text-white/80 transition-colors duration-200 whitespace-nowrap flex items-center gap-1.5 group"
                      >
                        <span className="w-1 h-1 rounded-full bg-white/20 group-hover:bg-[#00FF88] transition-colors duration-200 flex-shrink-0" />
                        {link.label}
                      </a>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Subscribe + Contact */}
            <div className="lg:w-72 flex-shrink-0">
              <p
                className="text-[#00FF88] text-sm font-bold mb-4 tracking-wider"
                style={{ fontFamily: 'Caveat, cursive', fontSize: '1rem' }}
              >
                订阅元宇宙动态
              </p>
              <p className="text-white/35 text-xs leading-relaxed mb-4">获取最新元宇宙技术动态、投融资资讯与生态进展，每周精选推送</p>
              {submitted ? (
                <div
                  className="flex items-center gap-2 px-4 py-3 mb-6"
                  style={{
                    background: 'rgba(0,255,136,0.08)',
                    border: '1.5px solid rgba(0,255,136,0.3)',
                    borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
                  }}
                >
                  <i className="ri-check-line text-[#00FF88]" />
                  <span className="text-[#00FF88] text-sm font-semibold" style={{ fontFamily: 'Caveat, cursive' }}>订阅成功！欢迎加入！</span>
                </div>
              ) : (
                <form data-readdy-form onSubmit={handleSubscribe} className="flex flex-col gap-3 mb-6">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入您的邮箱地址"
                    required
                    className="w-full px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none transition-colors duration-200"
                    style={{
                      background: 'rgba(255,255,255,0.04)',
                      border: '1.5px solid rgba(255,255,255,0.12)',
                      borderRadius: '12px 8px 14px 10px / 10px 14px 8px 12px',
                    }}
                  />
                  <button
                    type="submit"
                    disabled={submitting}
                    className="flex items-center justify-center gap-2 px-5 py-3 text-black font-bold text-sm transition-all duration-300 disabled:opacity-60 whitespace-nowrap cursor-pointer"
                    style={{
                      background: '#00FF88',
                      borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
                    }}
                  >
                    {submitting ? <i className="ri-loader-4-line animate-spin" /> : <><span style={{ fontFamily: 'Caveat, cursive', fontSize: '1rem' }}>立即订阅</span><i className="ri-arrow-right-line" /></>}
                  </button>
                </form>
              )}

              {/* Contact Info */}
              <div className="flex flex-col gap-3">
                <p className="text-white/30 text-xs font-bold tracking-widest uppercase mb-1">联系方式</p>
                <a href="tel:+8613810001256" className="flex items-center gap-2 text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0" style={{ color: '#00FF88' }}>
                    <i className="ri-phone-line text-sm" />
                  </div>
                  <span>(86) 138-1000-1256</span>
                </a>
                <a href="https://weixin.qq.com" className="flex items-center gap-2 text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0" style={{ color: '#00FF88' }}>
                    <i className="ri-wechat-line text-sm" />
                  </div>
                  <span>微信: 13810001256</span>
                </a>
                <a href="mailto:13810001256@126.com" className="flex items-center gap-2 text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0" style={{ color: '#00FF88' }}>
                    <i className="ri-mail-line text-sm" />
                  </div>
                  <span>13810001256@126.com</span>
                </a>
                <div className="flex items-start gap-2 text-white/50 text-sm">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5" style={{ color: '#00FF88' }}>
                    <i className="ri-map-pin-line text-sm" />
                  </div>
                  <span>大湾区清鉴META大厦</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Summary Section */}
        <div className="py-10 border-b border-white/8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Site Summary */}
            <div>
              <h4
                className="text-white font-bold text-base mb-4 flex items-center gap-2"
                style={{ fontFamily: 'Caveat, cursive', fontSize: '1.2rem' }}
              >
                <span style={{ color: '#00FF88' }}>✦</span>
                关于 META66
              </h4>
              <p className="text-white/35 text-xs leading-relaxed">
                META66（元宇宙66）是中国领先的元宇宙垂直综合资讯与生态平台，成立于2024年，总部位于大湾区。平台深度聚焦元宇宙、6G超连接、Web3.0至Web5.0演进、XR沉浸体验、数字孪生、量子计算、脑机接口、区块链等前沿科技领域，致力于成为全球华人元宇宙生态的核心枢纽。META66汇聚了来自全球的元宇宙研究者、技术开发者、内容创作者与投资机构，通过深度资讯、技术解析、生态连接与前沿培训，推动中国元宇宙产业的健康发展与全球化布局。
              </p>
            </div>
            {/* Disclaimer */}
            <div>
              <h4
                className="text-white font-bold text-base mb-4 flex items-center gap-2"
                style={{ fontFamily: 'Caveat, cursive', fontSize: '1.2rem' }}
              >
                <span style={{ color: '#FFD700' }}>⚠</span>
                免责声明
              </h4>
              <p className="text-white/30 text-xs leading-relaxed">
                本网站所有内容（包括但不限于文章、数据、预测、图表）仅供参考与学习交流，不构成任何投资建议或商业决策依据。关于未来技术发展的预测与展望均基于当前公开信息与合理推断，实际发展可能与预测存在重大差异。本站对第三方链接内容不承担任何责任。元宇宙相关数字资产投资存在高风险，请谨慎决策。本站保留对内容进行修改、更新或删除的权利，恕不另行通知。如有侵权内容，请联系我们及时处理。
              </p>
            </div>
          </div>
        </div>

        {/* RWA99 Partner Section */}
        <div className="py-10 border-b border-white/8">
          <div
            className="relative rounded-2xl p-8 overflow-hidden"
            style={{
              background: 'linear-gradient(135deg, rgba(255,180,0,0.06), rgba(255,107,53,0.06))',
              border: '1.5px solid rgba(255,180,0,0.2)',
              borderRadius: '20px 14px 22px 16px / 14px 22px 16px 20px',
            }}
          >
            {/* Doodle decorations */}
            <div className="absolute top-3 right-8 text-2xl opacity-20" style={{ color: '#FFD700', fontFamily: 'Caveat, cursive', transform: 'rotate(12deg)' }}>★</div>
            <div className="absolute bottom-3 left-12 text-xl opacity-15" style={{ color: '#FF6B35', fontFamily: 'Caveat, cursive', transform: 'rotate(-8deg)' }}>◆</div>
            <div className="absolute top-1/2 right-1/4 w-32 h-32 rounded-full pointer-events-none opacity-10" style={{ background: 'radial-gradient(ellipse, #FFD700 0%, transparent 70%)', transform: 'translateY(-50%)' }} />

            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <div
                    className="px-3 py-1 text-xs font-bold"
                    style={{
                      background: 'rgba(255,180,0,0.15)',
                      border: '1px solid rgba(255,180,0,0.4)',
                      borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
                      color: '#FFD700',
                      fontFamily: 'Caveat, cursive',
                      fontSize: '0.85rem',
                    }}
                  >
                    姊妹平台推介
                  </div>
                  <div className="w-1.5 h-1.5 rounded-full bg-[#FFD700] animate-pulse" />
                </div>
                <h3 className="text-white font-black text-2xl mb-2" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                  RWA<span style={{ color: '#FFD700' }}>99</span>.cn
                </h3>
                <p className="text-white/50 text-sm leading-relaxed max-w-lg">
                  中国领先的<strong className="text-[#FFD700]">现实世界资产（RWA）</strong>垂直资讯与生态平台。
                  深度聚焦房产代币化、债券上链、艺术品NFT、大宗商品数字化等RWA前沿领域，
                  连接传统金融与Web3.0生态，助力普通投资者参与高门槛资产投资。
                </p>
                <div className="flex flex-wrap gap-2 mt-4">
                  {['房产代币化', '债券上链', '艺术品NFT', 'DeFi融合', '合规监管'].map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 text-xs"
                      style={{
                        background: 'rgba(255,180,0,0.1)',
                        border: '1px solid rgba(255,180,0,0.25)',
                        borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
                        color: 'rgba(255,200,50,0.8)',
                        fontFamily: 'Caveat, cursive',
                        fontSize: '0.8rem',
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex flex-col items-center gap-4 flex-shrink-0">
                <div
                  className="w-24 h-24 flex items-center justify-center"
                  style={{
                    background: 'rgba(255,180,0,0.1)',
                    border: '2px solid rgba(255,180,0,0.4)',
                    borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%',
                    boxShadow: '0 0 30px rgba(255,180,0,0.15)',
                  }}
                >
                  <span className="font-black text-3xl" style={{ fontFamily: 'Orbitron, sans-serif', color: '#FFD700' }}>R99</span>
                </div>
                <a
                  href="https://www.rwa99.cn"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-6 py-3 font-bold text-sm cursor-pointer hover:scale-105 transition-all whitespace-nowrap"
                  style={{
                    background: 'rgba(255,180,0,0.15)',
                    border: '1.5px solid rgba(255,180,0,0.5)',
                    borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
                    color: '#FFD700',
                    fontFamily: 'Caveat, cursive',
                    fontSize: '1rem',
                    boxShadow: '0 0 20px rgba(255,180,0,0.15)',
                  }}
                >
                  <i className="ri-external-link-line" />
                  访问 RWA99.cn
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="py-8 border-b border-white/8">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
            {[
              { value: '128万+', label: '月活用户', color: '#00FF88', icon: 'ri-user-line' },
              { value: '50万+', label: '注册会员', color: '#FFD700', icon: 'ri-team-line' },
              { value: '12万+', label: '原创内容', color: '#FF6B9D', icon: 'ri-article-line' },
              { value: '180+', label: '生态伙伴', color: '#00FFCC', icon: 'ri-links-line' },
            ].map((stat) => (
              <div key={stat.label} className="flex items-center gap-3">
                <div
                  className="w-10 h-10 flex items-center justify-center flex-shrink-0"
                  style={{
                    background: `${stat.color}15`,
                    border: `1.5px solid ${stat.color}40`,
                    borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%',
                  }}
                >
                  <i className={`${stat.icon} text-sm`} style={{ color: stat.color }} />
                </div>
                <div>
                  <p className="font-black text-lg" style={{ color: stat.color, fontFamily: 'Orbitron, sans-serif' }}>{stat.value}</p>
                  <p className="text-white/30 text-xs">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <p className="text-white/20 text-xs">© 2025 META66.cn All Rights Reserved.</p>
            <span className="text-white/10 hidden sm:block">·</span>
            <p className="text-white/15 text-xs" style={{ fontFamily: 'Caveat, cursive' }}>构建未来数字文明 · Building Digital Civilization</p>
          </div>
          <div className="flex items-center gap-5 flex-wrap justify-center">
            {['隐私政策', '服务条款', 'Cookie政策', '版权声明'].map((l) => (
              <a key={l} href="#" className="text-white/20 text-xs hover:text-white/50 transition-colors duration-200 whitespace-nowrap">{l}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
